import {getAuth} from 'firebase/auth';
import React, {useEffect, useState} from 'react';
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import {Provider as AddeparProvider} from './contexts/AddeparContext';
import {Provider as AuthProvider} from './contexts/AuthContext';
import {Provider as BillProvider} from './contexts/BillContext';
import {Provider as BridgeProvider} from './contexts/BridgeContext';
import {Provider as PlaidProvider} from './contexts/PlaidContext';
import {Provider as RampProvider} from './contexts/RampContext';
import AddeparConnect from './routes/Addepar/AddeparConnect';
import RampConnect from './routes/Ramp/RampConnect';
import ClientAccounts from './routes/Admin/ClientAccounts';
import ClientDashboard from './routes/Admin/ClientDashboard';
import UserAccounts from './routes/Admin/UserAccounts';
import UserDashboard from './routes/Admin/UserDashboard';
import Login from './routes/Auth/Login';
import Signup from './routes/Auth/Signup';
import AccountPage from './routes/Plaid/AccountPage';
import AddConnectionPage from './routes/Plaid/AddConnectionPage';
import AddeparMappingsPage from './routes/Plaid/AddeparMappingsPage';
import AddeparPage from './routes/Plaid/AddeparPage';
import BillPage from './routes/Plaid/BillPage';
import BridgePage from './routes/Plaid/BridgePage';
import RampPage from './routes/Plaid/RampPage';
import Dashboard from './routes/Plaid/Dashboard';

const Content = () => {
  const [hasFetchedUserAuthState, setHasFetchedUserAuthState] = useState(false);
  const [userAuthState, setUserAuthState] = useState();

  const RequireAuth = ({children, redirectTo}) => {
    if (userAuthState === undefined) {
      return <></>;
    }
    return userAuthState ? (
      children || <Outlet />
    ) : (
      <Navigate to={redirectTo} />
    );
  };

  // TODO: will this work how we want or will it only set a listener one time
  // thats destroyed once they navgite from the page
  useEffect(() => {
    if (!hasFetchedUserAuthState) {
      const auth = getAuth();
      auth.onAuthStateChanged(function (user) {
        if (user) {
          setHasFetchedUserAuthState(true);
          setUserAuthState(user);
          // User is signed in.
        } else {
          // No user is signed in.
          setHasFetchedUserAuthState(true);
          setUserAuthState(false);
        }
      });
    }
  });

  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<Navbar user={userAuthState} />}>
            <Route path='/' element={<Login user={userAuthState} />} />
            <Route path='/signup' element={<Signup />} />
            <Route path='/login' element={<Login user={userAuthState} />} />
            <Route path='/' element={<RequireAuth redirectTo='/login' />}>
              <Route
                path='/admin/user/dashboard'
                element={<UserDashboard user={userAuthState} />}
              />
              <Route
                path='/admin/user/accounts/:id/:type'
                element={<UserAccounts user={userAuthState} />}
              />
              <Route
                path='/admin/client/dashboard'
                element={<ClientDashboard user={userAuthState} />}
              />
              <Route
                path='/admin/client/accounts/:id/:type'
                element={<ClientAccounts user={userAuthState} />}
              />
              <Route
                path='/dashboard'
                element={<Dashboard user={userAuthState} />}
              />
              <Route
                path='/add-connection'
                element={<AddConnectionPage user={userAuthState} />}
              />
              <Route
                path='/accounts/:item_id'
                element={<AccountPage user={userAuthState} />}
              />
              <Route
                path='/connections/:org_id'
                element={<BillPage user={userAuthState} />}
              />
              <Route
                path='/addepar/:connection_id'
                element={<AddeparPage user={userAuthState} />}
              />
              <Route
                path='/addepar/:connection_id/mappings/:entity_id'
                element={<AddeparMappingsPage user={userAuthState} />}
              />
              <Route
                path='/bridgeft/:item_id'
                element={<BridgePage user={userAuthState} />}
              />
              <Route
                path='/ramp/:connection_id'
                element={<RampPage user={userAuthState} />}
              />
              <Route
                path='/addeparConnect'
                element={<AddeparConnect user={userAuthState} />}
              />
              <Route
                path='/rampConnect'
                element={<RampConnect user={userAuthState} />}
              />
            </Route>
          </Route>
        </Routes>
      </Router>
    </>
  );
};

const App = () => {
  return (
    <RampProvider>
      <BridgeProvider>
        <AddeparProvider>
        <BillProvider>
          <PlaidProvider>
            <AuthProvider>
              <Content />
            </AuthProvider>
          </PlaidProvider>
        </BillProvider>
        </AddeparProvider>
      </BridgeProvider>
    </RampProvider>
  );
};

export default App;
